import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetMdText } from './useGetMdText'
import { MdTextContent } from './MdTextContent'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { IconWaitOutline } from '@icons/IconWaitOutline'

export const MdTextComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data, refetch } = useGetMdText(id, tileFilterSelections)

  return (
    <MdTextContent
      contentId={id}
      cachedResponse={data}
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
      reloadHandler={refetch}
    />
  )
}

export function MdTextComponentLoading() {
  return (
    <LoadingComponent
      className="h-full w-full"
      icon={<IconWaitOutline size={72} fontSize={96} />}
      text="Loading and parsing Markdown. For large files, this may take a little while..."
    />
  )
}
